function getkonva() {
    let width = Number(document.getElementById('container').style.width.replace('px', ''))
    let height = Number(document.getElementById('container').style.height.replace('px', ''))
    return [width, height]
};

function horizontal(img) {
    let scaleX = img.scaleX();
    let scaleY = img.scaleY();
    img.scale({ x: (scaleX *= -1), y: scaleY });
    if (img.attrs.flipX == 0 || img.attrs.flipX == -1) {
        img.attrs.flipX = 1;
        img.attrs.angle1 = img.attrs.rotation;
    }
    else {
        img.attrs.flipX = 0;
    }
};

function vertical(img) {
    let scaleX = img.scaleX();
    let scaleY = img.scaleY();
    img.scale({ x: scaleX, y: (scaleY *= -1) });
    if (img.attrs.flipY == 0) {
        img.attrs.flipY = 1;
    }
    else {
        img.attrs.flipY = 0;
    }
};

function top(img) {
    if (img.attrs.status != 'background')
        img.moveToTop();
};

function bottom(img) {
    if (img.attrs.status != 'background')
        img.moveToBottom();
};

function up(img) {

    img.moveUp();

};

function down(img) {
    if (img.attrs.status != 'background')
        img.moveDown();

};

function LeftAlignment(img) {
    img.x(img.width() * img.scaleX() / 2);
};

function Center(img) {
    img.x(300);
};

function RightAlignment(img) {
    img.x(600 - img.width() * img.scaleX() / 2);
};

function TopAlignment(img) {
    img.y(img.height() * img.scaleY() / 2);
};

function VerticalAlignment(img) {
    img.y(300);
};

function BottomAlignment(img) {
    img.y(600 - img.height() * img.scaleY() / 2);
};

function ClockwiseRotation(img) {
    img.rotate(45);
}

function CounterclockwiseRotation(img) {
    img.rotate(-45);
}

function amplification(img) {
    // let scale = img.scale().x + 0.1
    if (img.scale().x < 0 && img.scale().y < 0) {
        img.scale({ x: img.scale().x - 0.1, y: img.scale().y - 0.1 });
    }
    else if (img.scale().x < 0) {
        img.scale({ x: img.scale().x - 0.1, y: img.scale().y + 0.1 });
    } else if (img.scale().y < 0) {
        img.scale({ x: img.scale().x + 0.1, y: img.scale().y - 0.1 });
    } else {
        img.scale({ x: img.scale().x + 0.1, y: img.scale().y + 0.1 });
    }

}

function narrow(img) {
    // let scale = img.scale().x - 0.1
    if (img.scale().x < 0 && img.scale().y < 0) {
        img.scale({ x: img.scale().x + 0.1, y: img.scale().y + 0.1 });
    }
    else if (img.scale().x < 0) {
        img.scale({ x: img.scale().x + 0.1, y: img.scale().y - 0.1 });
    } else if (img.scale().y < 0) {
        img.scale({ x: img.scale().x - 0.1, y: img.scale().y + 0.1 });
    } else {
        img.scale({ x: img.scale().x - 0.1, y: img.scale().y - 0.1 });
    }
}

function opacity(img) {
    return img.getOpacity() * 100;
}

function imageFill(img) {
    let w = img.attrs.width;
    let h = img.attrs.height;
    let n = 0;
    let K = getkonva();
    if (w > h) {
        n = K[1] / h;
        w = K[0] * n;
        h = K[1];
    } else if (w == h) {
        if (K[0] > K[1]) {
            n = K[0] / w;
            w = K[0] * n;
            h = K[1];
        } else {
            n = K[1] / h;
            w = K[0] * n;
            h = K[1];
        }

    } else {
        n = K[0] / w;
        h = K[1] * n;
        w = K[0];
    }
    img.scale({ x: n, y: n });
    img.x((K[0] - w) / 2 + w / 2);
    img.y((K[1] - h) / 2 + h / 2);
}

function imageAdaptive(img) {
    let w = img.attrs.width;
    let h = img.attrs.height;
    let n = 0;
    let K = getkonva();
    if (w > h) {
        n = w / K[0];
        w = K[0];
        h = h / n;
    } else {
        n = h / K[1];
        h = K[1];
        w = w / n;
    }
    img.scale({ x: n, y: n });
    img.x((K[0] - w) / 2 + w / 2);
    img.y((K[1] - h) / 2 + h / 2);

}


export {
    horizontal,
    vertical,
    top,
    bottom,
    up,
    down,
    LeftAlignment,
    Center,
    RightAlignment,
    TopAlignment,
    VerticalAlignment,
    BottomAlignment,
    ClockwiseRotation,
    CounterclockwiseRotation,
    amplification,
    narrow,
    opacity,
    imageFill,
    imageAdaptive
};